import i18next from 'i18next';

import * as yup from 'yup';

import {PRODUCT_CONDITIONS, ValidationContext} from 'types';

export const createValidationContext = (reintroductionAllowed: boolean): ValidationContext => ({
    reintroductionAllowed,
});

export const generalInfoSchema = yup.object().shape({
    markingCode: yup
        .string()
        .trim()
        .required(i18next.t('components.form.required')),
    returnDate: yup
        .date()
        .nullable()
        .notRequired(),
    referenceDocNumber: yup.string().notRequired(),
    productCondition: yup
        .string()
        .oneOf([PRODUCT_CONDITIONS.FIT_FOR_SALE, PRODUCT_CONDITIONS.NOT_FIT_FOR_SALE])
        .required(i18next.t('components.form.required')),
    comment: yup
        .string()
        .nullable()
        .notRequired(),
    storageLocation: yup
        .number()
        .nullable()
        .when('productCondition', {
            is: PRODUCT_CONDITIONS.NOT_FIT_FOR_SALE,
            then: (schema) => schema.notRequired().nullable(),
            otherwise: (schema) => schema.required(i18next.t('components.form.required')),
        }),
    disposalReason: yup
        .string()
        .nullable()
        .when(['productCondition', '$reintroductionAllowed'], {
            is: (productCondition: PRODUCT_CONDITIONS, reintroductionAllowed: boolean) =>
                productCondition === PRODUCT_CONDITIONS.NOT_FIT_FOR_SALE ||
                (productCondition === PRODUCT_CONDITIONS.FIT_FOR_SALE && !reintroductionAllowed),
            then: (schema) => schema.required(i18next.t('components.form.required')),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),
});
